(function(){
  if(window.__aelizaReflectionPanelFixStateful)return;
  window.__aelizaReflectionPanelFixStateful=true;

  function scanValue(){
    var key='aeliza-reflection-local-scan-count';
    var n=parseInt(localStorage.getItem(key)||'0',10)||0;
    return String(n).padStart(6,'0');
  }

  function buildRow(){
    var row=document.createElement('div');
    row.setAttribute('data-aeliza-total-scans','true');
    var label=document.createElement('span');
    var value=document.createElement('strong');
    row.appendChild(label);
    row.appendChild(value);
    return row;
  }

  function fillRow(row){
    var label=row.querySelector('span');
    var value=row.querySelector('strong');
    if(label)label.textContent='SCAN COUNT';
    if(value)value.textContent=scanValue();
  }

  function resetInline(row){
    row.removeAttribute('style');
    Array.prototype.forEach.call(row.children,function(child){child.removeAttribute('style')});
  }

  function fix(){
    var root=document.querySelector('[data-self-reflection]');
    if(!root)return;

    var copy=root.querySelector('.self-reflection__copy');
    var analysis=root.querySelector('.self-reflection__analysis');
    var analysisVisible=analysis && !analysis.hasAttribute('hidden');
    var row=root.querySelector('[data-aeliza-total-scans]') || buildRow();

    fillRow(row);
    resetInline(row);

    if(analysisVisible){
      var firstEmotionRow=analysis.querySelector('.self-reflection__analysis-header:not([data-aeliza-total-scans])');
      row.className='self-reflection__analysis-header aeliza-scan-count-row';
      if(row.parentNode!==analysis){
        if(row.parentNode)row.parentNode.removeChild(row);
        analysis.insertBefore(row,firstEmotionRow || analysis.firstChild);
      }else if(firstEmotionRow && row.nextSibling!==firstEmotionRow){
        analysis.insertBefore(row,firstEmotionRow);
      }
      analysis.style.marginTop='22px';
      analysis.style.borderTop='1px solid var(--sr-line, #222)';
      row.style.marginTop='0';
      row.style.borderTop='0';
      row.style.borderBottom='1px solid var(--sr-line, #222)';
      if(firstEmotionRow)firstEmotionRow.style.borderTop='0';
    }else if(copy && copy.parentNode){
      row.className='self-reflection__analysis-header aeliza-scan-count-row';
      if(row.parentNode!==copy.parentNode){
        if(row.parentNode)row.parentNode.removeChild(row);
        copy.parentNode.insertBefore(row,copy.nextSibling);
      }else if(row.previousSibling!==copy){
        copy.parentNode.insertBefore(row,copy.nextSibling);
      }
      row.style.marginTop='22px';
      row.style.borderTop='1px solid var(--sr-line, #222)';
      row.style.borderBottom='1px solid var(--sr-line, #222)';
      if(analysis){
        analysis.style.marginTop='22px';
        analysis.style.borderTop='1px solid var(--sr-line, #222)';
      }
    }
  }

  function schedule(){
    fix();
    setTimeout(fix,80);
    setTimeout(fix,300);
    setTimeout(fix,900);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
  document.addEventListener('click',schedule,true);
  window.addEventListener('resize',schedule);
})();
